window.convertPdpCarousel = (() => {
  'use strict';

  const CLASS = 'convert-pdp-carousel';
  const SELECTOR = '.product__media-wrapper';

  const getWrappers = () => document.querySelectorAll(SELECTOR);

  const control = () => {
    getWrappers().forEach(el => el.classList.remove(CLASS));
  };

  const variant = () => {
    getWrappers().forEach(el => el.classList.add(CLASS));
  };

  const reset = () => {
    getWrappers().forEach(el => el.classList.remove(CLASS));
  };

  return { control, variant, reset };
})();
